import React, { useEffect, useState } from 'react';
import api from '@common/utils/api';
import ProductBoutiqueStore from './ProductBoutiqueStore';
import ProductBoutiqueStoresLine from './ProductBoutiqueStoresLine';
const ProductBoutiqueTabCountry = (props) => {
    const [stores, setStores] = useState([]);
    const [loading, setLoading] = useState(true);
    const [geo, setGeo] = useState();
    useEffect(() => {
        if (!props.pid) {
            setStores([]);
            setLoading(false);
        }
        else {
            setLoading(true);
            api.checkBoutiqueAvailability(props.pid, props.country, false, geo).then((data) => {
                if (data) {
                    setStores(data.stores);
                    setLoading(false);
                }
                else {
                    setLoading(false);
                }
            });
        }
    }, [props.pid, props.country, geo]);
    if (loading && (stores === null || stores === void 0 ? void 0 : stores.length) == 0) {
        return React.createElement(React.Fragment, null);
    }
    if (props.pid && (stores === null || stores === void 0 ? void 0 : stores.length) == 0) {
        return props.noResults;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(ProductBoutiqueStoresLine, { storescount: stores.length, setGeo: (e) => setGeo(e) }),
        stores.map((fs, idx) => (React.createElement(ProductBoutiqueStore, { key: fs.ID, index: idx + 1, store: fs, onReservePress: () => props.onStoreSelect(fs) })))));
};
export default ProductBoutiqueTabCountry;
